import { useLoadableAction } from 'ocfe/src/utilHooks/useLoadableAction';
import { isLoadSuccess, isLoading } from 'ocfe/src/utils/loadable';
import { useCallback } from 'react';
import OcApiRequest from 'src/Api/OcApiRequest';
import { TaggingConfig } from 'src/ItemTags/TaggingConfig';

export type TagGroup = {
    tagGroupKey: string;
    isUserCreated: boolean;
    isTopicTagGroup: boolean;
    tags: Tag[];
    sortOrder: number;
    name: string;
};

export type Tag = {
    tag: string;
    tagGroupName: string;
    tagKey: string;
    canUserEdit: boolean;
    isAlias: boolean;
    isUserCreated: boolean;
    isTopicTag: boolean;
    showAIIndicator: boolean;
    sortOrder?: number;
    isAdmin: boolean;
    minimalTagText?: string;
    tagType?: string;
};

export const loadTaggingConfig = (): Promise<TaggingConfig> => {
    return OcApiRequest.get<TaggingConfig>('/shared/tagging/globalconfig');
};

export const useTaggingConfig = () => {
    const [taggingConfigLoadable, doLoadTaggingConfig] = useLoadableAction(loadTaggingConfig);
    const load = useCallback(() => {
        if (!isLoadSuccess(taggingConfigLoadable) && !isLoading(taggingConfigLoadable)) {
            doLoadTaggingConfig();
        }
    }, [doLoadTaggingConfig, taggingConfigLoadable]);
    return [taggingConfigLoadable, load] as const;
};
